export function isWhitelisted(user) {
  if (['VCI', 'AccountManager', 'User', 'Admin'].includes(user.type)) {
    return true
  }

  return /^demo/.test(user.email)
}

export const whiteListEnabled = import.meta.env.VITE_DEALER_WHITELIST_ENABLED === 'true'